import type { Contract } from '@models/Contract'

import { apiClient } from '../../../gateways/api'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { fetchContracten, initialState }

const fetchContracten = async (
  filters: Partial<ContractinstellingenSearchFilters>,
): Promise<Contract[]> => {
  const { data } = await apiClient({
    url: '/rest/contract',
    method: 'GET',
  })

  return data.filter(createContractFilter(filters))
}

const initialState: {
  data: Contract[]
  query: { filters: ContractinstellingenSearchFilters }
} = {
  data: [],
  query: {
    filters: {
      combi: null,
    },
  },
}

const createContractFilter = (
  filters: Partial<ContractinstellingenSearchFilters>,
) => {
  return (contract: Contract): boolean => {
    const { combi } = filters

    if (combi) {
      if (contract.combi !== combi) {
        return false
      }
    }

    return true
  }
}
